export default __webpack_public_path__ + "static/media/aptis-teacher.d75497bf.png";